/*
 * @Author: llj
 * @Date: 2025-10-29 19:39:48
 * @LastEditors: llj
 * @LastEditTime: 2025-10-29 20:32:41
 * @Description:
 * @FilePath: \MXJC-Web\src\api\login.js
 */
import { request } from '@/utils/request';

// 获取图片验证码
export const getPicCode = params => request('/system/common/captcha/generate', 'get', params);

// 获取加密方式
export const getCryptoConfig = params => request('/system/common/getCryptoConfig', 'post', params);

// 登录页全局配置参数
export const getGlobalConfigs = params => request(`/system/common/getGlobalConfigs`, 'get', params);

// 账号密码登录
export const loginByText = params => request('/system/auth/loginByUsername', 'post', params);

// 获取用户信息
export const getUserInfo = () => request('/system/profile/currentUserInfo', 'get');

// 获取用户信息不脱敏
export const getUserInfoNoMask = () => request('/system/profile/currentUserInfoNoMask', 'get');

// 修改密码
export const changePwd = params => request('/system/profile/updatePassword', 'post', params);

//退出登录
export const loginOut = () => request('/system/auth/logout', 'get');

// 发送短信验证码
export const sendSms = params => request('/system/auth/getSmsCaptcha', 'post', params);

//手机验证码登录
export const loginBySms = params => request('/system/auth/loginBySmsCode', 'post', params);

// 获取账号下手机号
export const getCodeByAccount = params =>
  request('/system/auth/getSmsCaptchaByAccount', 'post', params);

// 忘记密码
export const forgetPwd = params => request(`/system/auth/forgotPassword`, 'POST', params);

// 忘记密码用 文本验证码获取账号下手机号验证码
export const getSmsCaptchaByAccount = params =>
  request('/system/auth/getSmsCaptchaByAccount', 'post', params);

// 手机号登录用 文本验证码获取账号下手机号验证码
export const getSmsCaptcha = params => request('/system/auth/getSmsCaptcha', 'post', params);

// 切换部门
export const switchDept = params => request(`system/auth/switchDept`, 'post', params);
